import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=51797136&scoped=true"
import script from "./DetailDialog.vue?vue&type=script&lang=js"
export * from "./DetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51797136",
  null
  
)

export default component.exports